import PHPURL from '../reducers/ReducerPHPURL';

export function getDomains() {

    let phpPath = PHPURL.baseURL + PHPURL.getDomains;

    return function(dispatch) {

        fetch(phpPath)
            .then(response => response.json())
            .then(data => {
                dispatch({
                    type: "DOMAINS",
                    payload: data.Domains
                })
            })
            .catch((error) => {
                dispatch({
                    type: "DOMAINS",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/getDomains.js